import DashboardConstants from "@/store/constants/dashboardRecords";
import GlobalConstants from "@/store/constants/global"
export default {
  name: "ConfirmModal",
  event: 'delete',
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('confirm-modal');
    },
    deleteRecord() {
      this.$emit('delete')

      const confirmAttr = this.$store.getters[GlobalConstants.GETTERS.getConfirmAttr];
      switch (true) {
        // co2Input
        // REFACTOR:
        case confirmAttr.attr == "attachedImageUrl": {
          this.$store.commit(DashboardConstants.COMMIT.setUrlImage, "");
          this.$store.commit(DashboardConstants.COMMIT.setPresignedUrlImage, "");
          //hide modal when delete attached Image
          this.$bvModal.hide('attached-image-modal');
          break;
        }case confirmAttr.attr == "SignHeader":{
          this.$store.commit('dashboardRecords/setDataHeaderSigns', { attr: "name", order: confirmAttr.orderId, value: "" })
          this.$store.commit('dashboardRecords/setDataHeaderSigns', { attr: "presignedUrl", order: confirmAttr.orderId, value: "" })
          this.$store.commit('dashboardRecords/setSignature', {
            order: confirmAttr.orderId,
            dataImage: "",
            signFor: confirmAttr.attr
          })
          break;
        }case confirmAttr.attr == "SignWorkRecord":{
          this.$store.commit('dashboardRecords/setDataInputWorkModal', { attr: "sign", index: -1, value: "" })
          this.$store.commit('dashboardRecords/setDataInputWorkModal', { attr: "presignedUrl", index: -1, value: "" })
          this.$store.commit('dashboardRecords/setSignature', {
            order: confirmAttr.orderId,
            dataImage: "",
            signFor: confirmAttr.attr
          })
          break;
        }case confirmAttr.attr == "SignCommonInstructions":{
          const path = confirmAttr.orderId
          this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: "commons." + path, value: "" });
          if(path == "supervisorPatrolRecord.supervisor"){
            this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: "commons." + "supervisorPatrolRecord.supervisorPresignedUrl", value: "" });
          }
          else if(path == "instructionDuringWork.instructor"){
            this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: "commons." + "instructionDuringWork.instructorPresignedUrl", value: "" });
          }
          this.$store.commit('dashboardRecords/setSignature', {
            order: confirmAttr.orderId,
            dataImage: "",
            signFor: confirmAttr.attr
          })
          break;
        } case ["co2InSiteWork", "co2OutSiteWork", "co2OutSiteWorkWaste", "co2OutSiteWorkContructionSoil", "workRecords", "inspections", "carryingIO", "safetyPlans", "safetyPlanImprovementPlans"].includes(confirmAttr.attr):
          if (["co2OutSiteWorkWaste", "co2OutSiteWorkContructionSoil"].includes(confirmAttr.attr)) {
            this.$store.commit(DashboardConstants.COMMIT.deleteRecord, { attr: "co2OutSiteWork", orderId: confirmAttr.orderId });
          }
          this.$store.commit(DashboardConstants.COMMIT.deleteRecord, { attr: confirmAttr.attr, orderId: confirmAttr.orderId });
          break;
        default:
          break;
      }
      //hide confirm modal
      this.hideModal();
      //reset confirmAttr in global
      this.$store.commit(GlobalConstants.COMMIT.setConfirmAttr, { attr: "", orderId: -1 });

    }
  },
};